<div class="custom-switch" [pTooltip]="tooltip | translate">
    <input type="checkbox" [id]="switchId" [formControl]="selectedValueControl" />
    <label [for]="switchId" class="switch-label">
        <span [class]="'switch-on ' + toggledIcon"></span>
        <span [class]="'switch-off ' + untoggledIcon"></span>
        <span class="switch-slider"></span>
    </label>
</div>
